(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.scrollFrame = null;
      this.pendingScrollAction = null;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.scrollFrame !== null) cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = null;
      this.pendingScrollAction = null;
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.header.classList.contains('scrolled-past-header')) this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        this.scheduleScrollAction('hide');
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.header.classList.contains('scrolled-past-header')) this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.scheduleScrollAction('reveal');
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.scheduleScrollAction('hide');
        }
      } else if (scrollTop <= this.headerBounds.top) {
        if (this.header.classList.contains('scrolled-past-header')) this.header.classList.remove('scrolled-past-header');
        this.scheduleScrollAction('reset');
      }

      this.currentScrollTop = scrollTop;
    }

    scheduleScrollAction(action) {
      // Always-sticky modes only need the threshold class updated above.
      if (this.headerIsAlwaysSticky) return;
      this.pendingScrollAction = action;
      if (this.scrollFrame !== null) return;
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        const pendingAction = this.pendingScrollAction;
        this.pendingScrollAction = null;
        this[pendingAction]();
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.header.classList.contains('shopify-section-header-hidden') || !this.header.classList.contains('shopify-section-header-sticky')) {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.header.classList.contains('shopify-section-header-sticky') || !this.header.classList.contains('animate')) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
      }
      if (this.header.classList.contains('shopify-section-header-hidden')) this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (['shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'].some((name) => this.header.classList.contains(name))) {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
